import { appReducer } from './app.reducer';
import { browserManagerReducer } from './browser-manager.reducer';

export const reducers = {
  app: appReducer,
  browser_manager: browserManagerReducer,
};

export * from './app.reducer';
export * from './browser-manager.reducer';
